export const getStatusBadgeColor = (value: string) => {
  switch (value) {
    case "Hold Insured":
      return { background: "rgba(138,100,3, 0.2)", text: "rgb(64,46,1)" };
    case "Hold Cust":
      return { background: "rgba(81,0,128, 0.2)", text: "rgb(81,0,128)" };
    case "In Progress":
    case "Active":
      return { background: "rgba(8,173,214, 0.2)", text: "rgb(5,69,84)" };
    case "Re-Opened":
    case "Not Habitable":
    case "Red Sticker - Not Habitable":
      return { background: "rgba(241,93,38, 0.2)", text: "rgb(189,73,29)" };
    case "AD Inv Ready":
      return { background: "rgba(45,23,191, 0.2)", text: "rgb(31,15,136)" };
    case "New":
    case "Yellow Sticker":
      return { background: "rgba(216,183,8, 0.2)", text: "rgb(167,141,5)" };
    case "PC Complete":
    case "Approved":
    case "Habitable - Safe for Occupation":  
      return { background: "rgba(5,138,58, 0.2)", text: "rgb(4,121,51)" };
    case "OpenedChart":
    case "Opened":
      return { background: "rgb(191,59,73)", text: "#fff" };
    case "ClosedChart":
    case "Closed":
      return { background: "#9c9c9c", text: "#000" };
    case "TRIAGE_CANNOT_PROCEED":
      return { background: "rgba(241,93,38, 0.2)", text: "rgb(189,73,29)" };
    case "OWNER_CONFIRMATION_COMPLETED":
      return { background: "rgba(138,100,3, 0.2)", text: "rgb(64,46,1)" }; 
    case "GENERAL_COMPLETED":
      return { background: "rgba(81,0,128, 0.2)", text: "rgb(81,0,128)" };
    case "DAMAGE_COMPLETED":
      return { background: "rgba(45,23,191, 0.2)", text: "rgb(31,15,136)" };
    case "CONTENTS_COMPLETED":
      return { background: "rgba(45,23,191, 0.2)", text: "rgb(31,15,136)" };
    case "FULLY_COMPLETED":
      return { background: "rgba(5,138,58, 0.2)", text: "rgb(4,121,51)" };
      
    default:
      return { background: "rgba(108,117,125, 0.2)", text: "rgb(52,57,62)" };
  }
};

export const getGanttColor = (
  startDate: string,
  endDate: string,
  completed: number
) => {
  const taskStartDate = new Date(startDate);
  const taskEndDate = new Date(endDate);
  const today = new Date();

  if (
    (today > taskStartDate && completed === 0.0) ||
    (today > taskEndDate && completed < 100.0)
  ) {
    return {
      background: "rgba(210,29,54, 0.6)",
      text: "rgb(255,255,255)",
      progress: "rgb(210,29,54)"
    };
  }

  if (completed !== 100.0) {
    return {
      background: "rgba(11,97,255, 0.6)",
      text: "rgb(255,255,255)",
      progress: "rgb(11,97,255)"
    };
  } else {
    return {
      background: "rgba(136, 204, 2, 0.6)",
      text: "rgb(255,255,255)",
      progress: "rgb(136, 204, 2)"
    };
  }
};

// export const getGanttColor2 = (id: number) => {
//   switch (id) {
//     case 1:
//       return {
//         background: "rgba(138,100,3, 0.75)",
//         text: "rgb(255,255,255)",
//         progress: "rgb(138,100,3)"
//       };
//     case 2:
//       return {
//         background: "rgba(81,0,128, 0.75)",
//         text: "rgb(255,255,255)",
//         progress: "rgb(81,0,128)"
//       };
//     case 3:
//       return {
//         background: "rgba(8,173,214, 0.75)",
//         text: "rgb(255,255,255)",
//         progress: "rgb(8,173,214)"
//       };
//     case 4:
//       return {
//         background: "rgba(241,93,38, 0.75)",
//         text: "rgb(255,255,255)",
//         progress: "rgb(241,93,38)"
//       };
//     case 5:
//       return {
//         background: "rgba(45,23,191, 0.75)",
//         text: "rgb(255,255,255)",
//         progress: "rgb(45,23,191)"
//       };
//     case 6:
//       return {
//         background: "rgba(216,183,8, 0.75)",
//         text: "rgb(255,255,255)",
//         progress: "rgb(216,183,8)"
//       };
//     case 7:
//       return {
//         background: "rgba(5,138,58, 0.75)",
//         text: "rgb(255,255,255)",
//         progress: "rgb(5,138,58)"
//       };
//     default:
//       return {
//         background: "rgba(108,117,125, 0.75)",
//         text: "rgb(255,255,255)",
//         progress: "rgb(108,117,125)"
//       };
//   }
// };


//https://web.archive.org/web/20120507054320/http://codeaid.net/javascript/convert-size-in-bytes-to-human-readable-format-(javascript)
export const bytesToSize = (bytes: number, precision: number) => {
  var kilobyte = 1024;
  var megabyte = kilobyte * 1024;
  var gigabyte = megabyte * 1024;
  var terabyte = gigabyte * 1024;

  if (bytes >= 0 && bytes < kilobyte) {
    return bytes + " B";
  } else if (bytes >= kilobyte && bytes < megabyte) {
    return (bytes / kilobyte).toFixed(precision) + " KB";
  } else if (bytes >= megabyte && bytes < gigabyte) {
    return (bytes / megabyte).toFixed(precision) + " MB";
  } else if (bytes >= gigabyte && bytes < terabyte) {
    return (bytes / gigabyte).toFixed(precision) + " GB";
  } else if (bytes >= terabyte) {
    return (bytes / terabyte).toFixed(precision) + " TB";
  } else {
    return bytes + " B";
  }
}